export function ListOfPaged() {
    return [20, 50, 100];
}

export function MinimumPage() {
    return 3;
}